import React from 'react'
const Checkmark = () => (
  <svg width='11' height='9' viewBox='0 0 11 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path opacity='0.8' d='M1 5L4 8L10 1' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export default Checkmark
